module.exports = __webpack_public_path__ + "static/media/Memories_main_t.fb627399.jpg";